var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{attrs:{"right":"","variant":"custom-primary"},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('i',{staticClass:"fas fa-plus mr-2"}),_vm._v(" Nouvelle question ")]},proxy:true}])},[_c('b-dropdown-item',{attrs:{"to":{
      name: _vm.baseUrl + '-create',
      params: { id: _vm.currentChecklist.id, type: 'qcm' },
    },"exact":""}},[_c('i',{staticClass:"fas fa-plus align-middle mr-1"}),_vm._v(" Question a chox multiples (QCM)")]),_c('b-dropdown-item',{attrs:{"to":{
      name: _vm.baseUrl + '-create',
      params: { id: _vm.currentChecklist.id, type: 'qrm' },
    },"exact":""}},[_c('i',{staticClass:"fas fa-plus align-middle mr-1"}),_vm._v("Question a réponse multiples (QRM)")]),_c('b-dropdown-item',{attrs:{"to":{
      name: _vm.baseUrl + '-create',
      params: { id: _vm.currentChecklist.id, type: 'qvf' },
    },"exact":""}},[_c('i',{staticClass:"fas fa-plus align-middle mr-1"}),_vm._v("Question Vrai/Faux (QVF)")]),_c('b-dropdown-item',{attrs:{"to":{
      name: _vm.baseUrl + '-create',
      params: { id: _vm.currentChecklist.id, type: 'qrn' },
    },"exact":""}},[_c('i',{staticClass:"fas fa-plus align-middle mr-1"}),_vm._v("Question a réponse numérque (QRN)")]),_c('b-dropdown-item',{attrs:{"to":{
      name: _vm.baseUrl + '-create',
      params: { id: _vm.currentChecklist.id, type: 'qrc' },
    },"exact":""}},[_c('i',{staticClass:"fas fa-plus align-middle mr-1"}),_vm._v("Question a réponse courte (QRC)")]),_c('b-dropdown-item',{attrs:{"to":{
      name: _vm.baseUrl + '-create',
      params: { id: _vm.currentChecklist.id, type: 'qrl' },
    },"exact":""}},[_c('i',{staticClass:"fas fa-plus align-middle mr-1"}),_vm._v("Question a réponse longue (QRL)")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }